var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.panelTheme},[(_vm.hasHeaderSlot)?_c('div',{class:_vm.panelHeaderTheme},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2),(_vm.hasFooterSlot)?_c('div',{class:_vm.panelFooterTheme},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }